import { useEffect, useState } from 'react';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { useMediaQuery } from 'planoplan-ui-kit/core/hooks/useMediaQuery';
import { Points } from '@styles';
import { IS_SERVER } from '@constants';

// на сервере ориентируемся на юзер агента
export const useRenderOnlyDevice = (device = 'laptop') => {
  const isDevice = device === 'laptop' ? !deviceDetected.isMobile : deviceDetected.isMobile;
  const [isRender, setIsRender] = useState(isDevice);

  if (IS_SERVER) {
    return isRender;
  }

  const isPoint = useMediaQuery(Points.laptop, { useSSR: false });

  useEffect(() => {
    setIsRender(device === 'laptop' ? isPoint : !isPoint);
  }, [isPoint]);

  return isRender;
};
